import { useRef, useEffect, useCallback } from "react";
import { toast } from 'react-toastify';
import { Template, checkTemplate, getInputFromTemplate } from "@pdfme/common";
import { Viewer } from "@pdfme/ui";
import {
  getFontsData,
  getBlankTemplate,
  generatePDF,
  downloadJsonFile
} from "../helper";
import { getPlugins } from '../plugins';
import { NavItem, NavBar } from "components/NavBar";
import { AReportAPI } from "api/admin/a_report_api";
import { useParams } from "react-router-dom";
import {Button} from "react-bootstrap";


function ViewerPage() {
  const params = useParams();
  const uiRef = useRef<HTMLDivElement | null>(null);
  const ui = useRef<Viewer | null>(null);

  if (!params.reportId) {
    throw new Error("reportId is required");
  }
  const reportId = params.reportId;

  const buildUi = useCallback(async () => {
    if (!uiRef.current) return;
    try {
      let template: Template = getBlankTemplate();

      const report = await AReportAPI.get(reportId);
      checkTemplate(report.templateFile);
      template = report.templateFile;
      const inputs = report.inputs ?? getInputFromTemplate(template);
      
      ui.current = new Viewer({
        domContainer: uiRef.current,
        template,
        inputs,
        options: {
          font: getFontsData(),
          lang: 'ja',
          labels: { 'signature.clear': 'Clear' },
          theme: {
            token: {
              colorPrimary: '#25c2a0',
            },
          },
        },
        plugins: getPlugins(),
      });
    } catch {
      localStorage.removeItem("inputs");
      localStorage.removeItem("template");
    }
  }, []);


  useEffect(() => {
    buildUi();
    return () => {
      if (ui.current) {
        ui.current.destroy();
      }
    };
  }, [uiRef, buildUi]);

  const navItems: NavItem[] = [
    {
      label: "",
      content: (
        <div className="d-flex">
          <Button
            id="generate-pdf"
            onClick={async () => {
              const startTimer = performance.now()
              await generatePDF(ui.current);
              const endTimer = performance.now()
              toast.info(`Generated PDF in ${Math.round(endTimer - startTimer)}ms ⚡️`);
            }}
          >
            PDFを出力
          </Button>
          <Button onClick={() => downloadJsonFile(ui.current?.getInputs(), "output")}>
            JSONを出力
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <NavBar items={navItems} />
      <div ref={uiRef} />
    </>
  );
}

export default ViewerPage;
